<template>
    <section class="container-fluid content-type-37 actions">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8">
                    <div class="content">
                        <div class="buttons">
                            <button class="btn-2 btn-m-icon" @click="routeToMode()">
                                <div class="icon-company-neg"></div>
                                <span>{{$t('links.companies')}}</span>
                            </button>
                            <button class="btn-7 btn-m-icon" :class="{'btn-paywall': paywall}" :disabled="paywall" @click="routeToMode('new')">
                                <div v-if="paywall" class="paywall-lock"></div>
                                <div class="icon-new-pos"></div>
                                <span>{{$t('links.suspect')}}</span>
                            </button>
                            <button class="btn-1 btn-m-icon" @click="routeToMode('prospects')">
                                <div class="icon-target-pos"></div>
                                <span>{{$t('links.prospects')}}</span>
                            </button>
                        </div>

                        <div class="buttons">
                            <button class="btn-6 btn-s-icon" @click="fetchStats" :disabled="loading">
                                <div class="icon-reset-pos"></div>
                                <span>{{$t('views.audience.buttons.recalculate_2')}}</span>
                                <div v-if="loading" class="loading-spinner-type-1"></div>
                            </button>
                        </div>
                        <div class="p notice">{{$t(stats?.stats_exact ? 'views.audience.notices.exact' : 'views.audience.notices.estimation')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import i18n from "@/plugins/i18n";
    import { mapActions, mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import { useToastStore } from '@/stores/utils/toast';

    export default {
        name: "DashboardActions",
        data() {
            return {
                loading: false,
            };
        },
        computed: {
            ...mapState(useAccountStore, ['stats', 'paywall']),
        },
        methods: {
            ...mapActions(useAccountStore, ['fetchProspectsStats']),
            routeToMode(mode = 'all') {
                switch (mode) {
                    case 'new':
                        this.$router.push({ name: 'suspects'});
                        break;
                    case 'prospects':
                        this.$router.push({ name: 'prospects' });
                        break;
                    default:
                        this.$router.push({ name: 'companies' });
                        break;
                }
            },
            async fetchStats() {
                this.loading = true;
                await this.fetchProspectsStats();
                useToastStore().addToast(i18n.global.t('toasts.success.stats_recalculated'), 'success');
                this.loading = false;
            }
        },
    }
</script>